// extracted by mini-css-extract-plugin
export default {"container":"diagram_container__9-5Aq","diagram":"diagram_diagram__Bk9QJ"};